export const COMPLICITY_ROUTE_PREFIX = "/settings/complicities";

export const COMPLICITY_ROUTE_PATHS = {
  list: { path: "*", to: COMPLICITY_ROUTE_PREFIX },
};
